import { PhTextColumns } from '@phosphor-icons/vue'

import { type BuilderBlockModule } from '@/lib/builder/types'
import i18nPlugin from '@/plugins/i18n'

import {
  type ScrollingSection,
  type ScrollingSectionCreate,
  type ScrollingSectionUpdate,
  type WebsiteResource,
} from '../../WebsiteBuilder.types'
import { websiteBlockMethods } from '../common/methods'

import ScrollingEditor from './editor/ScrollingEditor.vue'
import { createScrollingData } from './methods/createScrollingData'
import ScrollingPreview from './preview/ScrollingPreview.vue'
const i18n = i18nPlugin.global

export const ScrollingBlockModule: BuilderBlockModule<
  ScrollingSection,
  ScrollingSectionCreate,
  ScrollingSectionUpdate,
  WebsiteResource
> = {
  createData: createScrollingData,
  editor: ScrollingEditor,
  meta: [
    {
      icon: PhTextColumns,
      key: 'scrolling',
      label: i18n.t('website-builder.blocks.scrolling'),
    },
  ],
  methods: websiteBlockMethods,
  preview: ScrollingPreview,
}
